import {useParams} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {Skeleton} from '@/components/ui/skeleton'
import {NoAccessState} from '@/components/no-access-state'
import {ExpedienteChrome} from '@/components/expediente-chrome'
import {ExpedienteNotFound, ExpedienteEmptySnapshot} from '@/components/expediente-empty'
import {SectionCard} from '@/components/section-card'
import {useExpedienteEntry, useExpedienteBateria} from '@/hooks/sgsst/expediente/use-expediente'
import {formatDateOnly} from '@/lib/risk'

/** Solo agregados de grupo del año: nivel global y periodicidad (Res. 2764/2022 art. 3), nunca
 * cifras por dimensión ni datos individuales (custodia art. 5). */
export function ExpedienteBateriaPage() {
  const {t} = useTranslation()
  const {businessId, year: yearParam} = useParams()
  const year = Number(yearParam)
  const {canOperate, isLoading, exp} = useExpedienteEntry(businessId, year)
  const {data} = useExpedienteBateria(businessId, year, canOperate && !!exp)

  if (!canOperate) return <NoAccessState />
  if (isLoading) return <Skeleton className="h-40 w-full" />
  if (!exp) return <ExpedienteNotFound businessId={businessId!} year={year} />

  const base = `/businesses/${businessId}`
  const periodicidadCopy =
    data?.periodicidad_meses === 12
      ? t('bateria.consolidado.anual')
      : data?.periodicidad_meses === 24
        ? t('bateria.consolidado.bienal')
        : t('bateria.consolidado.sinDato')

  return (
    <ExpedienteChrome exp={exp} backTo={`${base}/expediente/${year}`} backLabel={t('expediente.backToIndex', {year})}>
      <div className="space-y-4" data-testid="expediente-bateria">
        <p className="text-xs text-muted-foreground">{t('expediente.vistas.bateria.custodia')}</p>
        {!data?.disponible ? (
          <>
            <h2 className="font-mono text-[11px] font-semibold tracking-wider text-muted-foreground uppercase">
              {t('expediente.sections.bateria')}
            </h2>
            <ExpedienteEmptySnapshot message={t('expediente.vistas.bateria.sinEntrega', {year})} />
          </>
        ) : (
          <SectionCard
            title={t('expediente.sections.bateria')}
            bodyClassName="space-y-2"
            testId="expediente-bateria-consolidado">
            {data.fecha_aplicacion !== null && (
              <p className="text-sm text-foreground">
                {t('expediente.vistas.bateria.aplicada', {fecha: formatDateOnly(data.fecha_aplicacion)})}
              </p>
            )}
            <p className="text-xs text-muted-foreground">{periodicidadCopy}</p>
            {data.proxima_aplicacion !== null && (
              <p className="text-sm text-foreground" data-testid="expediente-bateria-proxima">
                {t('bateria.consolidado.proxima', {fecha: formatDateOnly(data.proxima_aplicacion)})}
              </p>
            )}
          </SectionCard>
        )}
      </div>
    </ExpedienteChrome>
  )
}
